import { gql } from "@apollo/client"

export const GET_ANSWERS = gql`
query GetAnswersByCondition ($searchCriteria:String!,$searchId:UUID, $query:String, $first: Int,$after:String, $answerGroup:AnswerGroup){
  answersByCondition (searchCriteria: $searchCriteria,searchId:$searchId, query:$query,first:$first, after:$after,answerGroup: $answerGroup) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges{
      cursor
      node {
        id
        data
        sentimentAnalysisData
        keyWordExtractionData
        question {
          __typename
          id
          title
          category
          questionSet
          language
          position
          type
        }
        session{
          location {
            companyId
          }
        }
      }
    }
  }
}`